import {
    RequestKeys,
} from 'app/hooks/useRequest'
import ChangeHistory from 'app/shared-components/ChangeHistory'

import config from 'app/requests/Container/DamageType.requests'

const DamageTypeChangeHistory = ({
    id,
}: { id: number }) => {
    return (
        <ChangeHistory
            id={id}
            requestKey={RequestKeys.getDamageModifications}
            config={config.modifications}
            configName="DamageTypeChangeHistoryTable"
            name="DamageTypeChangeHistory"
            labelPrefixForChangedColumn={['DamageTypes']}
        />
    )
}

export default DamageTypeChangeHistory
